import { render, staticRenderFns } from "./RoleSections.vue?vue&type=template&id=8fbebe36&"
import script from "./RoleSections.vue?vue&type=script&lang=js&"
export * from "./RoleSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports